import { checkTosAndSCWallet, onboardUser } from '$lib/util/common';
import { signMessage, type SignMessageResult } from '@wagmi/core';
import axios from 'axios';
import { tosBeingSigned } from '../popupsStore';
import { logAnalytcisEvent } from '$lib/util/analytics';

export async function postTosSignature(
	address: `0x${string}`,
	signature: SignMessageResult,
	scWalletAccountResolver: `0x${string}`
) {
	const response = await axios.post(
		'https://earn-api.polynomial.fi/tos',
		{
			address,
			signature
		},
		{
			headers: {
				'content-type': 'application/json',
				'Access-Control-Allow-Origin': '*'
			}
		}
	);
	if (response.status === 200 || response.status == 201) {
		await checkTosAndSCWallet(scWalletAccountResolver);
		return response.data;
	}
}

export async function getTosSigned(address: string) {
	const response = await axios.get(`https://earn-api.polynomial.fi/tos/${address}`, {
		headers: {
			'content-type': 'application/json',
			'Access-Control-Allow-Origin': '*'
		}
	});
	if (response.status === 200) {
		return response.data;
	}
}

export async function signMessageAndSendToServer(
	address: `0x${string}`,
	scWalletAccountResolver: `0x${string}`
) {
	logAnalytcisEvent('click_sign_tos', {});
	tosBeingSigned.set(true);
	const message = `
    I agree to Polynomial's Terms of Service and Privacy Policy.

    I am not a person or entities who reside in, are citizens of, are incorporated in, or have a registered office in the United States of America or any Prohibited Localities, as defined in the Terms & Conditions.

    I am lawfully permitted to access this site and use Polynomial under the laws of the jurisdiction on which I reside and am located.

    I will not in the future access this site or use Polynomial while located within the United States or any Prohibited Localities, as defined in the Terms & Conditions.

    https://www.polynomial.fi/terms-conditions and https://www.polynomial.fi/privacy-policy

    Wallet address: ${address}
    `;

	const signature: SignMessageResult = await signMessage({
		message
	});
	const response = await postTosSignature(address, signature, scWalletAccountResolver);
	console.log({ response });
	tosBeingSigned.set(false);

	//Continue onboarding
	onboardUser('Tos');
}
